'use strict';

angular.module('theme').service('Toast', function ($timeout, $window, $translate, toastr) {

	this.success = function (key, vars) {
		return toastr.success($translate.instant(key, vars));
	};

	this.error = function (key, vars) {
		return toastr.error($translate.instant(key, vars));
	};

	this.successContent = function(content, redirectUrl, time) {
		var timeout = time || 3000;

		if (redirectUrl) {
			$timeout(function() {
				$window.location.href = redirectUrl;
			}, timeout);
		}

		return toastr.success('<div class="splash-content"><i class="mk-icon mk-icon-close-white"></i>' + content + '</div>', {
			allowHtml: true,
			toastClass: 'splash',
			timeOut: timeout,
			tapToDismiss: true
		});
	};

	this.errorRaw = function (msg) {
		if (msg) {
			return toastr.error(msg);
		}
	};

});
